module.exports = __webpack_public_path__ + "img/date_24.9f731158.svg";